import { type ReactNode, type CSSProperties } from 'react';
import { useInView } from '../../hooks/useInView';

interface FadeUpProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'article';
}

export function FadeUp({ children, delay = 0, className = '', as: Tag = 'div' }: FadeUpProps) {
  const { ref, isInView } = useInView(0.01);

  const style: CSSProperties = isInView
    ? {
        opacity: 1,
        transform: 'translateY(0)',
        transition: `opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s`,
      }
    : {
        opacity: 0.001,
        transform: 'translateY(20px)',
      };

  return (
    <Tag ref={ref} className={className} style={style}>
      {children}
    </Tag>
  );
}
